export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Bottle deposit',
    },
    product_type: {
      label: 'Product Type',
      options: {
        packaged: 'Packaged',
        prepared: 'Prepared',
      },
    },
    packaging_material: {
      label: 'Packaging material',
    },
    brand_or_manufacturer: {
      label: 'Brand or manufacturer',
    },
    net_quantity: {
      label: 'Net quantity',
    },
    base_price: {
      label: 'Set price per unit (e.g. per liter for a drink)',
      placeholder: 'Price per unit',
    },
    alcohol_by_volume_percent: {
      label: 'Alcohol percentage',
    },
    caffeine_mg_per_100ml: {
      label: 'Caffeine (mg per 100ml of product)',
    },
    ingredients_text: {
      label: 'Ingredients',
    },
    allergens_list: {
      label: 'Allergens',
    },
    additives_list: {
      label: 'Additives',
    },
    has_nutrition_table: {
      label: 'Fill nutrition table (per 100{{unit}} of product)',
    },
    energy_kj: {
      label: 'Energy (kJ)',
    },
    energy_kcal: {
      label: 'Energy (kcal)',
    },
    fat_g: {
      label: 'Fat',
    },
    saturates_g: {
      label: 'Saturates',
    },
    carbohydrate_g: {
      label: 'Carbohydrate',
    },
    sugars_g: {
      label: 'Sugar',
    },
    protein_g: {
      label: 'Protein',
    },
    salt_g: {
      label: 'Salt',
    },
    identifiers: {
      label: 'Identifiers',
    },
  },
};
